module.exports = __webpack_public_path__ + "assets/img/911bed18ab63014ef8442087e4e97591.svg";